module.exports = __webpack_public_path__ + "static/media/placeholder-default.abaa09b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder-default.svg
// module id = 852
// module chunks = 1